import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Textarea } from "./ui/textarea";
import { Apple, Smartphone } from "lucide-react";
import { CallAPIPromise } from "../billing/common";


export function EditVersionDialog({
  open,
  onOpenChange,
  app,
  platform,
  onSave,
}) {
  const [formData, setFormData] = useState({
    version: "",
    buildNumber: "",
    status: "development" ,
    notes: "",
  });

  useEffect(() => {
    if (app && platform) {
      setFormData({
        version: platform === "ios" ? app.iosVersion : app.androidVersion,
        buildNumber: platform === "ios" ? app.iosBuildNumber : app.androidBuildNumber,
        status: platform === "ios" ? app.iosStatus : app.androidStatus,
        notes: "",
      });
    }
  }, [app, platform]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (app && platform) {
      console.log(app)
        CallAPIPromise(`/api/crossMobileAppVersion/editVersion/${app.id}`,{
            "id": app.id,
            "name": app.name,
            "iosVersion": platform ==="ios"?formData.version:app.iosVersion,
            "iosBuildNumber": platform ==="ios"?formData.buildNumber:app.iosBuildNumber,
            "iosStatus":platform ==="ios"?formData.status:app.iosStatus,
            "androidVersion": platform ==="android"?formData.version:app.androidVersion,
            "androidBuildNumber": platform ==="android"?formData.buildNumber:app.androidBuildNumber,
            "androidStatus": platform ==="android"?formData.status:app.androidStatus,
            "lastUpdated":app.lastUpdated,
            "createdAt": app.createdAt,
            "updatedAt": app.updatedAt,

        }).then((res)=>{
          console.log(res)
        })
      onSave(app.id, platform, formData);
      onOpenChange(false);
    }
  };

  if (!app || !platform) return null;

  const platformIcon = platform === "ios" ? <Apple className="w-5 h-5" /> : <Smartphone className="w-5 h-5" />;
  const platformName = platform === "ios" ? "iOS" : "Android";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {platformIcon}
            Edit {platformName} Version - {app.name}
          </DialogTitle>
          <DialogDescription>
            Update version information and release status for {platformName}.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="version">Version Number</Label>
                <Input
                  id="version"
                  value={formData.version}
                  onChange={(e) => setFormData({ ...formData, version: e.target.value })}
                  placeholder="1.0.0"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="buildNumber">Build Number</Label>
                <Input
                  id="buildNumber"
                  value={formData.buildNumber}
                  onChange={(e) => setFormData({ ...formData, buildNumber: e.target.value })}
                  placeholder="1"
                  required
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="status">Release Status</Label>
              <Select
                value={formData.status}
                onValueChange={(value) => setFormData({ ...formData, status: value  })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="development">Development</SelectItem>
                  <SelectItem value="testing">Testing</SelectItem>
                  <SelectItem value="production">Production</SelectItem>
                  <SelectItem value="archived">Archived</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="notes">Release Notes (optional)</Label>
              <Textarea
                id="notes"
                value={formData.notes}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                placeholder="What's new in this version..."
                rows={4}
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit">Save Changes</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
